/**
 * @module app.shared
 */

/**
 * Access a property on the given object using a chained property accessor specified by `path`
 *
 *  NOTE: DOES NOT support:
 *  - index accessors `a[0].b`
 *    - however, array elements can be accessed with dot notation `a.0.b`
 *  - property names with dots `a['b.c']`
 * @param target the target object
 * @param path a period-delimited list of simple property names
 * @returns the value of the given property, or `undefined` if it doesn't exist
 */
export function resolveProperty(target: any, path: string): any {
    // NOTE: does not support
    // - index accessors `a[0].b`
    //   - however, array elements can be accessed with dot notation `a.0.b`
    // - property names with dots `a['b.c']`
    if(!path) { return target; }
    return path.split('.').reduce((prev, curr) => prev ? prev[curr] : undefined, target);
}

/**
 * Check if a property exists on the target object using a chained property accessor specified by `path`
 *
 *  NOTE: DOES NOT support:
 *  - index accessors `a[0].b`
 *    - however, array elements can be accessed with dot notation `a.0.b`
 *  - property names with dots `a['b.c']`
 * @param target the target object
 * @param path a dot notation string of simple property names
 * @returns `true` if the `path` property is in the target object
 */
export function hasProperty(target: any, path: string): boolean {
    if(typeof target !== 'object' || !path) { return false; }

    const lastDotIndex = path.lastIndexOf('.');
    if(lastDotIndex === -1) { return Reflect.has(target, path) }

    const checkProperty: string = path.slice(lastDotIndex + 1);
    const testObject: any = resolveProperty(target, path.slice(0, lastDotIndex));
    return testObject ? Reflect.has(testObject, checkProperty) : false;
}
